export default __webpack_public_path__ + "static/media/idea-napkin.45880f3f.svg";